import { InMemoryCache } from '@apollo/client';
import { typePolicies } from './typePolicies';



export function init() {
  return new InMemoryCache({
    typePolicies
  });
}
